import '../Sidebar/Sidebar.css';
import React from "react";
import { NavLink } from "react-router-dom";

export default function SidebarItem({ item, onNavigate }) {
    return (
        <NavLink
            to={item.link}
            onClick={onNavigate}
            className={({ isActive }) => [
                "sidebarLink",
                isActive ? "sidebarLinkActive" : ""
            ].join(" ").trim()}
        >
            {item.name}
        </NavLink>
    );
}
